var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
let Modal = class Modal extends Vue {
    close() {
        return false;
    }
};
__decorate([
    Prop({ default: true })
], Modal.prototype, "show", void 0);
__decorate([
    Prop({ default: true })
], Modal.prototype, "loading", void 0);
__decorate([
    Prop({ default: true })
], Modal.prototype, "showCloseBtn", void 0);
__decorate([
    Emit('close')
], Modal.prototype, "close", null);
Modal = __decorate([
    Component({
        name: 'Modal',
    })
], Modal);
export default Modal;
